import { Item } from '../../../../../store/types'
import Carousel from './CustomCarousel'
import { t } from 'i18next'
import { Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import i18n from '../../../../../config/i18n'
import { environment } from '../../../../../enviroments/enviroment'

const translationBase = `components.infoSidebar.schedule.carousel.tracked`
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/tracked`

const LIGHT_PL_1 = `${urlBase}/tracked-light-PL-1.png`
const LIGHT_PL_2 = `${urlBase}/tracked-light-PL-2.png`
const LIGHT_PL_3 = `${urlBase}/tracked-light-PL-3.png`
const LIGHT_PL_4 = `${urlBase}/tracked-light-PL-4.png`
const LIGHT_PL_5 = `${urlBase}/tracked-light-PL-5.png`

const DARK_PL_1 = `${urlBase}/tracked-dark-PL-1.png`
const DARK_PL_2 = `${urlBase}/tracked-dark-PL-2.png`
const DARK_PL_3 = `${urlBase}/tracked-dark-PL-3.png`
const DARK_PL_4 = `${urlBase}/tracked-dark-PL-4.png`
const DARK_PL_5 = `${urlBase}/tracked-dark-PL-5.png`

const LIGHT_EN_1 = `${urlBase}/tracked-light-EN-1.png`
const LIGHT_EN_2 = `${urlBase}/tracked-light-EN-2.png`
const LIGHT_EN_3 = `${urlBase}/tracked-light-EN-3.png`
const LIGHT_EN_4 = `${urlBase}/tracked-light-EN-4.png`
const LIGHT_EN_5 = `${urlBase}/tracked-light-EN-5.png`

const DARK_EN_1 = `${urlBase}/tracked-dark-EN-1.png`
const DARK_EN_2 = `${urlBase}/tracked-dark-EN-2.png`
const DARK_EN_3 = `${urlBase}/tracked-dark-EN-3.png`
const DARK_EN_4 = `${urlBase}/tracked-dark-EN-4.png`
const DARK_EN_5 = `${urlBase}/tracked-dark-EN-5.png`

const TrackedCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.table.subtitle`),
      description: (
        <Stack gap={2}>
          <Typography>{t(`${translationBase}.table.description-1`)}</Typography>
          <Typography>
            <Trans i18nKey={`${translationBase}.table.description-2`} />
          </Typography>
          <Typography>
            <Trans i18nKey={`${translationBase}.table.description-3`} />
          </Typography>
        </Stack>
      ),
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-schedule-info-tracked-1',
    },
    {
      subtitle: t(`${translationBase}.details.subtitle`),
      description: t(`${translationBase}.details.description`),
      imageLight: isPolish ? LIGHT_PL_2 : LIGHT_EN_2,
      imageDark: isPolish ? DARK_PL_2 : DARK_EN_2,
      key: 'carousel-schedule-info-tracked-2',
    },
    {
      subtitle: t(`${translationBase}.modify.subtitle`),
      description: t(`${translationBase}.modify.description`),
      imageLight: isPolish ? LIGHT_PL_3 : LIGHT_EN_3,
      imageDark: isPolish ? DARK_PL_3 : DARK_EN_3,
      key: 'carousel-schedule-info-tracked-3',
    },
    {
      subtitle: t(`${translationBase}.errors.subtitle`),
      description: t(`${translationBase}.errors.description`),
      imageLight: isPolish ? LIGHT_PL_4 : LIGHT_EN_4,
      imageDark: isPolish ? DARK_PL_4 : DARK_EN_4,
      key: 'carousel-schedule-info-tracked-4',
    },
    {
      subtitle: t(`${translationBase}.errorDetails.subtitle`),
      description: t(`${translationBase}.errorDetails.description`),
      imageLight: isPolish ? LIGHT_PL_5 : LIGHT_EN_5,
      imageDark: isPolish ? DARK_PL_5 : DARK_EN_5,
      key: 'carousel-schedule-info-tracked-5',
    },
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default TrackedCarousel
